import React, { memo, forwardRef } from "react";
const SvgLeftHalfOpenInterval = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M2.108 20.962c-.648-2.034-.972-3.104-.972-5.21s.324-3.167.972-5.183c.648-2.034 1.503-3.807 2.565-5.319.216-.306.468-.459.756-.459.234 0 .432.081.594.243a.722.722 0 01.243.567c0 .18-.072.387-.216.621-.954 1.476-1.719 3.132-2.295 4.968-.558 1.836-.837 2.69-.837 4.562 0 1.872.279 2.726.837 4.562.576 1.836 1.341 3.492 2.295 4.968.144.234.216.441.216.621a.722.722 0 01-.243.567.808.808 0 01-.594.243c-.288 0-.54-.153-.756-.459-1.062-1.512-1.917-3.276-2.565-5.292zM17.574 21.097l-1.54 4.698c-.161.468-.44.702-.836.702a.935.935 0 01-.648-.243.72.72 0 01-.27-.594c0-.144.027-.306.08-.486l1.432-4.617c.144-.522.45-.783.918-.783.27 0 .495.081.675.243.18.162.27.378.27.648 0 .09-.027.234-.081.432zM29.224 26.74h-2.7c-.54 0-.81-.243-.81-.729s.27-.729.81-.729h1.971V6.222h-1.971c-.54 0-.81-.243-.81-.729s.27-.729.81-.729h2.7c.702 0 1.053.351 1.053 1.053v19.87c0 .702-.351 1.053-1.053 1.053z"
      />
    </svg>
  );
});
SvgLeftHalfOpenInterval.displayName = "SvgLeftHalfOpenInterval";
const MemoForwardRef = memo(SvgLeftHalfOpenInterval);
export default MemoForwardRef;
